import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";

import type { ReactNode } from "react";

interface DesktopFiltersToolbarProps {
  children: ReactNode;
  clearAllFilters: (() => void) | undefined;
}

export default function DesktopFiltersToolbar({
  children,
  clearAllFilters,
}: DesktopFiltersToolbarProps) {
  const hasFilters = !!clearAllFilters;

  return (
    <div className="flex gap-x-1.5 flex-1 relative">
      <div className="flex gap-1.5 flex-1 flex-wrap">{children}</div>

      <RenderIf condition={hasFilters}>
        <Button variant="link-danger" size="sm" onClick={clearAllFilters}>
          Clear all
        </Button>
      </RenderIf>
    </div>
  );
}
